import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getRimsBySize } from 'utils/api/articleSearchAPI'
import { createResultSelector } from 'utils/helper'
import { statusHandler, thunkActions } from 'utils/utils'
import { loggedOut } from 'utils/redux/commonActions'
import searchRimType from 'utils/enums/searchRimType'


export const searchRims = createAsyncThunk('industryRimSearch/search', async (criteria) => await getRimsBySize(
	criteria.boltPattern,
	criteria.boltCircle,
	criteria.diameter,
	criteria.width,
	criteria.articleText,
	criteria.rimType,
	criteria.languageCode
))

const searchRimsActions = thunkActions(searchRims)

const industryRimSearchSlice = createSlice({
	name: 'industryRimSearch',
	initialState: {
		status: 'idle',
		result: null,
		filterIds: null,
		filterState: null,
		sortBy: null,
		ascending: null,
		criteria: {
			width: '',
			boltPattern: '',
			boltCircle: '',
			diameter: '',
			rimType: searchRimType.industry,
			selectedSize: '',
			articleText: ''
		}
	},
	reducers: {
		setCriteria: (state, action) => {
			state.criteria[action.payload.name] = action.payload.value
		},
		setFilter: (state, action) => {
			state.filterIds = action.payload.articleIds
			state.filterState = action.payload.filterState
		},
		sortResult: (state, action) => {
			state.sortBy = action.payload.sortBy
			state.ascending = action.payload.ascending
		}
	},
	extraReducers: builder => {
		builder
			.addCase(loggedOut, state => {
				state.status = 'idle'
				state.result = null
				state.filterIds = null
				state.criteria = {
					width: '',
					boltPattern: '',
					boltCircle: '',
					diameter: '',
					rimType: searchRimType.industry,
					selectedSize: '',
					articleText: ''
				}
			})
			.addCase(searchRims.pending, state => {
				state.filterIds = null
				state.filterState = null
				state.result = null
				state.sortBy = null
				state.ascending = null
			})
			.addCase(searchRims.fulfilled, (state, action) => {
				state.result = action.payload
			})
			.addMatcher(searchRimsActions, statusHandler)
	}
})

export const selectCritiera = state => state.search.rim.industryRim.criteria
export const selectStatus = state => state.search.rim.industryRim.status
export const selectResult = state => state.search.rim.industryRim.result
export const selectFilterIds = state => state.search.rim.industryRim.filterIds
export const selectFilterState = state => state.search.rim.industryRim.filterState
export const selectSortBy = state => state.search.rim.industryRim.sortBy
export const selectAscending = state => state.search.rim.industryRim.ascending

export const selectProcessedResult = createResultSelector(selectResult, selectFilterIds, selectSortBy, selectAscending)

export const { setCriteria, sortResult, setFilter } = industryRimSearchSlice.actions

export default industryRimSearchSlice.reducer
